<qloc-card class="{{class}}" [footer]="footer" [title]="title">
    <qloc-col-media [url]="url" [link]="link" [image]="image" [alt]="alt" [iframe]="iframe" [size]="size" [left]="left" [downloads]="downloads" [mediastyle]="mediastyle">
        <ng-content></ng-content>
    </qloc-col-media>
</qloc-card>